
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

import Image from '@hems/component/src/image/Image.vue';

import type { StringSelectorOption } from 'hems';

export default defineComponent({
  name: 'DropdownMenu',
  components: { Image },
  props: {
    selectedValue: {
      type: String,
      default: '',
    },
    items: {
      type: Array as PropType<StringSelectorOption[]>,
      default: () => [],
    },
  },
  emits: ['click'],
});
